/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Thursday, December 9th 2021, 7:36:32 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */
import React from "react";
import { UseAPIFormReturn } from "lib/api";

/**
 * Context provider OneStop API Form for OneStop API objects/models.
 */

export const OSAPIFormContext = React.createContext<UseAPIFormReturn<any>>(null);

export const useOSAPIFormContext = <T,>() => {
  return React.useContext(OSAPIFormContext as React.Context<UseAPIFormReturn<T>>);
};

interface OSAPIFormProviderProps<TAPIFormData, TAPIResponse> {
  children: React.ReactNode;
  useAPIFormReturn: UseAPIFormReturn<TAPIFormData, TAPIResponse>;
}

export const OSAPIFormProvider = <TAPIFormData, TAPIResponse>({
  children,
  useAPIFormReturn,
}: OSAPIFormProviderProps<TAPIFormData, TAPIResponse>) => {
  return <OSAPIFormContext.Provider value={useAPIFormReturn}>{children}</OSAPIFormContext.Provider>;
};
